var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "sm-12" },
        [
          _c(
            "q-table",
            {
              ref: "table",
              attrs: {
                loading: _vm.loading,
                error: _vm.error,
                items: _vm.items,
                fields: _vm.fields,
                "new-item": _vm.newItem
              },
              on: { "toggle-details": _vm.toggleDetails },
              scopedSlots: _vm._u([
                {
                  key: "cell(photo)",
                  fn: function(row) {
                    return [
                      _c(
                        "div",
                        { staticClass: "position-relative" },
                        [
                          !_vm.photosEmpty(row.item)
                            ? _c(
                                "viewer",
                                {
                                  attrs: {
                                    trigger: row.item.photos,
                                    rebuild: ""
                                  },
                                  on: { inited: _vm.setViewer }
                                },
                                _vm._l(row.item.photos, function(src, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: src,
                                      staticClass: "position-absolute",
                                      staticStyle: { left: "50%" }
                                    },
                                    [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: i === 0,
                                            expression: "i === 0"
                                          }
                                        ],
                                        staticClass:
                                          "photo-field position-relative",
                                        attrs: {
                                          src: _vm.$global.storagePath(
                                            "inventory",
                                            row.item.id,
                                            src
                                          ),
                                          title:
                                            row.item.photos.length > 1
                                              ? "еще " +
                                                (row.item.photos.length - 1) +
                                                " фото"
                                              : undefined
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              class: !_vm.photosEmpty(row.item)
                                ? ["position-absolute", "mt-3", "ml-2"]
                                : undefined,
                              attrs: {
                                pill: true,
                                size: !_vm.photosEmpty(row.item) ? "xs" : "sm"
                              },
                              on: {
                                click: function($event) {
                                  _vm.$refs["file-" + row.item.id].$el
                                    .querySelector("input[type=file]")
                                    .click()
                                }
                              }
                            },
                            [
                              _vm.photosEmpty(row.item)
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "camera" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus", size: "xs" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-file", {
                            ref: "file-" + row.item.id,
                            staticClass: "position-absolute invisible",
                            staticStyle: { width: "0" },
                            attrs: { accept: ".png, .jpg", multiple: "" },
                            on: {
                              input: function(files) {
                                return _vm.uploadPhotos(row.item, files)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "cell(description)",
                  fn: function(row) {
                    return [
                      row.item.description && !row.item._edit
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.item.description) +
                                "\n        "
                            )
                          ])
                        : row.item._edit
                          ? _c("b-form-input", {
                              staticClass: "text-center",
                              attrs: { size: "sm" },
                              model: {
                                value: row.item.description,
                                callback: function($$v) {
                                  _vm.$set(row.item, "description", $$v)
                                },
                                expression: "row.item.description"
                              }
                            })
                          : _c("i", [_vm._v(_vm._s(_vm.$t("empty")))])
                    ]
                  }
                },
                {
                  key: "cell(actions)",
                  fn: function(row) {
                    return [
                      !row.item._edit
                        ? _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                title: _vm.$t("button.edit"),
                                variant: "info"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.table.toggleEdit(row.item)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "edit" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                title: _vm.$t("button.confirm"),
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confirmEdit(row.item, row.index)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "check" }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          attrs: {
                            title: _vm.$t("button.delete"),
                            variant: "danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteInventory(row.item)
                            }
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "row-details",
                  fn: function(row) {
                    return [
                      _c("h6", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("sorting")))
                      ]),
                      _vm._v(" "),
                      row.item.stocks && row.item.stocks.length
                        ? _vm._l(row.item.stocks, function(stock) {
                            return _c(
                              "b-row",
                              { key: stock.id, staticClass: "mt-1" },
                              [
                                _c("b-col", { attrs: { cols: "6", xs: "3" } }, [
                                  _c("b", { staticClass: "float-right" }, [
                                    _vm._v(_vm._s(stock.name))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "2", md: "1" } },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        disabled: !row.item._edit,
                                        type: "number",
                                        size: "sm",
                                        min: "0",
                                        number: ""
                                      },
                                      on: { keydown: _vm.isNumber },
                                      model: {
                                        value: stock.count,
                                        callback: function($$v) {
                                          _vm.$set(stock, "count", $$v)
                                        },
                                        expression: "stock.count"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        : _c("i", [_vm._v(_vm._s(_vm.$t("empty")))])
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "top-actions" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.createSpare }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "plus" } }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("button.create")) +
                          "\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }